import React from 'react';

const VendorListItem = ({ vendor, isSelected, onClick }) => {
  return (
    <div 
      className={`vendor-item ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
    >
      <div className="vendor-item-header">
        <h3>{vendor.description}</h3>
        {vendor.unreadCount > 0 && (
          <span className="unread-badge">{vendor.unreadCount}</span>
        )}
      </div>
      <p className="vendor-last-message">{vendor.name}</p>
    </div>
  );
};

export default VendorListItem;